import { create } from "zustand";

interface VerifiedState {
  showVerified: boolean;
  setShowVerified: (value: boolean) => void;
  verifiedLabel: string;
  setVerifiedLabel: (value: string) => void;
  showRejected: boolean;
  setShowRejected: (value: boolean) => void;
  showGenerated: boolean;
  setShowGenerated: (value: boolean) => void;
}

export const useVerifiedStore = create<VerifiedState>((set) => ({
  showVerified: false,
  setShowVerified: (value) => set({ showVerified: value }),
  verifiedLabel: "",
  setVerifiedLabel: (value) => set({ verifiedLabel: value }),
  showRejected: false,
  setShowRejected: (value) => set({ showRejected: value }),
  showGenerated: false,
  setShowGenerated: (value: boolean) => set({ showGenerated: value }),
}));
